/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_LabelInputs */

const en_image_inspector_label = /** @type {(inputs: Image_Inspector_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~/ inspector`)
};

const ar_image_inspector_label = /** @type {(inputs: Image_Inspector_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~/ الفاحص`)
};

const bn_image_inspector_label = /** @type {(inputs: Image_Inspector_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~/ ইন্সপেক্টর`)
};

const de_image_inspector_label = /** @type {(inputs: Image_Inspector_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~/ Inspektor`)
};

const es_image_inspector_label = /** @type {(inputs: Image_Inspector_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~/ inspector`)
};

const fr_image_inspector_label = /** @type {(inputs: Image_Inspector_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~/ inspecteur`)
};

const pt_image_inspector_label = /** @type {(inputs: Image_Inspector_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~/ inspetor`)
};

const zh_image_inspector_label = /** @type {(inputs: Image_Inspector_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~/ 检查器`)
};

const tr_image_inspector_label = /** @type {(inputs: Image_Inspector_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~/ denetçi`)
};

const ru_image_inspector_label = /** @type {(inputs: Image_Inspector_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~/ инспектор`)
};

const pl_image_inspector_label = /** @type {(inputs: Image_Inspector_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~/ inspektor`)
};

/**
* | output |
* | --- |
* | "~/ inspector" |
*
* @param {Image_Inspector_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_label = /** @type {((inputs?: Image_Inspector_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_label(inputs)
	if (locale === "bn") return bn_image_inspector_label(inputs)
	if (locale === "de") return de_image_inspector_label(inputs)
	if (locale === "es") return es_image_inspector_label(inputs)
	if (locale === "fr") return fr_image_inspector_label(inputs)
	if (locale === "pt") return pt_image_inspector_label(inputs)
	if (locale === "zh") return zh_image_inspector_label(inputs)
	if (locale === "tr") return tr_image_inspector_label(inputs)
	if (locale === "ru") return ru_image_inspector_label(inputs)
	if (locale === "pl") return pl_image_inspector_label(inputs)
	return en_image_inspector_label(inputs)
});